const { TrendingUp, CheckCircle, AccountBalance } = require("@mui/icons-material");
const { Box, Typography, Stack, CardContent, Card, Grid } = require("@mui/material");

// Format number with commas
export const formatNumber = (num) => {
  return new Intl.NumberFormat("ar-EG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

// Summary Cards Component
const SummaryCards = ({ summary }) => {
  const cards = [
    {
      title: "إجمالي الأصول",
      value: summary.total_assets,
      icon: <AccountBalance />,
      color: "#1976d2",
    },
    {
      title: "إجمالي الخصوم وحقوق الملكية",
      value: summary.total_liabilities_equity,
      icon: <TrendingUp />,
      color: "#9c27b0",
    },
    {
      title: "حالة التوازن",
      value: summary.balance_check ? "متوازن" : "غير متوازن",
      icon: <CheckCircle />,
      color: summary.balance_check ? "#2e7d32" : "#d32f2f",
      isStatus: true,
    },
  ];

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      {cards.map((card, index) => (
        <Grid item xs={12} md={4} key={index}>
          <Card
            elevation={3}
            sx={{
              background: `linear-gradient(135deg, ${card.color}15 0%, ${card.color}05 100%)`,
              border: `1px solid ${card.color}30`,
              transition: "transform 0.2s",
              "&:hover": {
                transform: "translateY(-4px)",
              },
            }}
          >
            <CardContent>
              <Stack direction="row" spacing={2} alignItems="center">
                <Box
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    bgcolor: `${card.color}20`,
                    color: card.color,
                    display: "flex",
                  }}
                >
                  {card.icon}
                </Box>
                <Box flex={1}>
                  <Typography variant="body2" color="text.main" gutterBottom>
                    {card.title}
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" color="primary.main">
                    {card.isStatus ? card.value : formatNumber(card.value)}
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default SummaryCards;
